import { getIsServerEnv } from '@/shared/modules/environment';

export function mergeQueryParams(url: string, customQuery: object) {
  if (getIsServerEnv()) {
    return url;
  }
  const resultUrl = new URL(url);

  Object.entries(customQuery).forEach(([key, value]) => {
    resultUrl.searchParams.set(key, value);
  });

  return resultUrl.toString();
}
